// Redux access for this package, typed to the ONLY slice it owns.
//
// Each app keeps its own `stores/hooks` bound to its own `RootState` — the two
// root states differ (web-admin has no selector slice) and a shared package
// cannot name either. What both roots do have is `auth`, so these hooks are
// typed to exactly that much and nothing more.
import type { Dispatch, UnknownAction } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";

import type { AuthState } from "../api/redux-toolkit/reducer/authSlice";

/** The minimum root state this package can work against. */
export interface WithAuthState {
  auth: AuthState;
}

/**
 * Plain action dispatch. Deliberately not the app's `AppDispatch` (which
 * carries thunk typing): nothing in this package dispatches a thunk, and
 * naming the app's store type is what coupled these modules to one app.
 */
export type AuthDispatch = Dispatch<UnknownAction>;

export const useAuthDispatch = (): AuthDispatch => useDispatch<AuthDispatch>();

export const useAuthSelector = <T>(selector: (state: WithAuthState) => T): T =>
  useSelector(selector);
